import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { AGE_RANGE_OPTIONS } from '../constants';
import flattenDeep from 'lodash/array';
import union from 'lodash/array';
import t from 'tcomb-form';
import { EmailRefinement } from '../utils/tcomb-utils';
import CityAutosuggestFactory from '../components/CityAutosuggest';
import { WebsiteRefinement, WebsiteTransformer } from '../utils/tcomb-utils';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';

import {
  loadCollageOrganizations,
  openSignupFormRequest,
  openLoginFormRequest
} from '../actions';



import HomeCollage from '../components/HomeCollage';
import SharedStoryStep1 from '../components/sharedStory/SharedStoryStep1';
import SharedStoryStep2 from '../components/sharedStory/SharedStoryStep2';
import SharedStoryStep3 from '../components/sharedStory/SharedStoryStep3';
import SharedStoryStep4 from '../components/sharedStory/SharedStoryStep4';
import SharedStoryStep5 from '../components/sharedStory/SharedStoryStep5';

const PAGES = {
  Step1: SharedStoryStep1,
  Step2: SharedStoryStep2,
  Step3: SharedStoryStep3,
  Step4: SharedStoryStep4,
  Step5: SharedStoryStep5
}



class SharedStory extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    pageStep: PAGES.Step1,
    seenIntroPage: false
  }

  componentWillMount() {
    // Test that user hasn't already submitted story
    if (this.props.auth.user !== null) {
      let sharedStories = this.props.auth.user.author;
      if (sharedStories.length != 0) {
        this.props.push('/shared-story-detail/' + sharedStories[0].id);
      }
    }


  }

  componentWillReceiveProps(nextProps) {

    // Test that user hasn't already submitted story
    if (this.props.auth.user !== null) {
      let sharedStories = this.props.auth.user.author;
      if (sharedStories.length != 0) {
        this.props.push('/shared-story-detail/' + sharedStories[0].id);
      }
    }

    if (nextProps.auth.user !== null  && this.state.seenIntroPage) {
      this.setState({
        hasAlreadyLoggedIn: true
      });
      this.goToStep2();
    }
  }

  openAuthModal = (e) => {
    e.preventDefault()
    this.setState({
      seenIntroPage: true
    });
    this.props.openLoginFormRequest({next: '/shared-story'});
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }


  goToStep1 = () => {
    this.setState( {pageStep: PAGES.Step1 });
  }

  goToStep2 = () => {
    this.setState( {pageStep: PAGES.Step2 });
  }

  goToStep3 = () => {
    this.setState( {pageStep: PAGES.Step3 });
  }

  goToStep4 = () => {
    this.setState( {pageStep: PAGES.Step4 });
  }

  goToStep5 = () => {
    this.setState( {pageStep: PAGES.Step5 });
  }

  render() {

    const { auth } = this.props;
    if (!auth.loggedIn) {
      //this.openAuthModal
    }

    let sharedStory = this.props.sharedStory;

    let Tag = this.state.pageStep;

    let tag = '';

    if (this.state.pageStep == PAGES.Step1) {
      tag = <Tag goToStep2 = {this.goToStep2} sharedStory = {sharedStory} auth = {this.props.auth} openAuthModal = {this.openAuthModal} />
    } else if (this.state.pageStep == PAGES.Step2) {
      tag = <Tag goToStep1 = {this.goToStep1} goToStep3 = {this.goToStep3} sharedStory = {sharedStory} />
    } else if (this.state.pageStep == PAGES.Step3) {
      tag = <Tag goToStep4 = {this.goToStep4} sharedStory = {sharedStory} auth = {this.props.auth} browser = {this.props.browser}/>
    } else if (this.state.pageStep == PAGES.Step4) {
      tag = <Tag goToStep5 = {this.goToStep5} sharedStory = {sharedStory} />
    } else if (this.state.pageStep == PAGES.Step5) {
      tag = <Tag sharedStory = {sharedStory} />
    }

    let buttonCollage = 'We can\'t wait to hear from you, ';

    let pageHeader = '';
    if (this.state.pageStep == PAGES.Step5) {
      pageHeader = <div className="sharedStory-header"><h1 className="page-heading">Thank you!</h1></div>
    } else {
      pageHeader = <div className="sharedStory-header"><h1 className="page-heading">WorldWideWomen Making a Difference</h1></div>
    }

    return(
      <main>
        <div className="content-wrapper">
          <HomeCollage collageOrganizations={this.props.collageOrganizations}
                       loadCollageOrganizations={this.props.loadCollageOrganizations}
                       browser={this.props.browser}
                       auth={this.props.auth}
                       buttonCollage={buttonCollage}
                       header='Share your story with us'
                       />
          <div className="sharedStory-outerWrapper">


            {pageHeader}

            {tag}




          </div>
        </div>
      </main>

    )
  }
}

function mapStateToProps(state) {
 return state;
}



export default connect(
  mapStateToProps,
  {
    push,
    loadCollageOrganizations,
    openSignupFormRequest,
    openLoginFormRequest
 })(SharedStory);



// WEBPACK FOOTER //
// ./src/containers/SharedStory.jsx